export default __webpack_public_path__ + "static/media/Medico-Mobile.a37af75b.jpg";